
class MidiAction {
    constructor(type) {
        this.type = type;
    }

    // given a midi value 0-127 execute the action
    execute(val) {}
}

export default MidiAction;
